import { useL10n } from '@ews/react-localization-context';
import { IonButton, IonIcon, IonModal } from '@ionic/react';
import { close } from 'ionicons/icons';
import React, { useCallback, useState } from 'react';
import { injectHTML as h } from '../../utils';
import { env } from '../Environment';
import style from './Modal.module.scss';

export function useModal()
{
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [content, setContent] = useState<React.ReactNode>(null);

    // This opens the modal with any content you want
    const openModal = useCallback((modalContent: React.ReactNode) =>
    {
        setContent(modalContent);
        setIsModalOpen(true);
    }, []);

    const closeModal = useCallback(() => setIsModalOpen(false), []);

    // Modal renders whatever is passed as content
    const modal = (
        <IonModal isOpen={isModalOpen} onDidDismiss={closeModal} className={style.modal}>
            <div className={style.modalContainer}>
                <div className={style.closeButtonContainer}>
                    <IonButton fill="clear" size="small" onClick={closeModal}>
                        <IonIcon icon={close} slot="icon-only" />
                    </IonButton>
                </div>
                {content}
            </div>
        </IonModal>
    );

    return { openModal, closeModal, modal };
}

export function LegalModalContent()
{
    const { translate: t } = useL10n();

    return (
        <div>
            {/*  <div className={imprintStyle.closeButtonContainer}>
                <IonButton fill="clear" size="small" onClick={onClose}>
                    <IonIcon icon={close} slot="icon-only" />
                </IonButton>
            </div> */}
            <h3 className={style.heading}>LABOR STRAUSS Sicherungsanlagenbau GmbH</h3>
            <p>Wiegelestrasse 36</p>
            <p>A-1230 {t('[REACT_VIENNA]')}</p>
            <a href="https://www.laborstrauss.com/" className={style.link}>www.laborstrauss.com</a>
            <h3 className={style.heading}>{t('COM_VIRTUEMART_STORE_FORM_LEGAL')}</h3>
            <p>{t('[REACT_COMPANY_REGISTRATION_NUMBER]')}: 125977k</p>
            <p>{t('[REACT_COMPANY_REGISTER_COURT]')}</p>
            <p>{t('VMUSERFIELD_ISTRAXX_EUVATCHECKER_EUVAT_VATNUMBER')}: ATU14715806</p>
            <p>{t('[REACT_E-COMMERCE_LAW]')}</p>
            <p>{t('[REACT_MEMBER_OF_THE_VIENNA_CHAMBER_OF_COMMERCE]')}</p>
            <p>{t('[REACT_MANAGEMENT]')}: Dipl.-Ing. Helmut Friedl, Dipl.-Ing Stefan Friedl</p>
        </div>
    );
}

export function GuidelineModalContent()
{
    const { translate: t } = useL10n();

    return (
        <div>
            <h3 className={style.heading}>{t('[REACT_GUIDELINES]')}</h3>
            <p>{t('[REACT_GUIDELINE_TEXT]')}</p>
        </div>
    );
}

const getReactURL = (serviceUrl: string) =>
{
    const { hostname } = new URL(serviceUrl);

    if (hostname.toLowerCase().endsWith('ews.lstwien')) return 'https://services.ews.lstwien';
    if (hostname.toLowerCase().endsWith('ews.lst.at')) return 'https://react.ews.lst.at';
    if (hostname.toLowerCase().endsWith('staging.newreact.com')) return 'https://staging.newreact.com';

    return 'https://newreact.com';

};

export function MoreInformation()
{
    const { translate: t, getLocale } = useL10n();
    const currentLocale = getLocale();
    const react_service_url = getReactURL(env.APP_SERVICE_URL);

    return (
        <div>
            <h1 className={style.heading}>{h(t("[REACT_MORE_INFO_TITLE1]"))}</h1>
            <h2>{t("[REACT_MORE_INFO_REMOTE_ACCESS]")}</h2>
            <p></p>
            <p>{t("[REACT_MORE_INFO_DEVICES]")}</p>
            <p></p>

            <h2>{t("[REACT_MORE_INFO_TITLE2]")}</h2>
            <p>{h(t("[REACT_MORE_INFO_DEVICE_APP_STORE]"))}</p>
            <p>{h(t("[REACT_MORE_INFO_WEB]", {
                react_service_url,
                link_class: style.link
            }))}</p>

            <p> <a className={style.link} target="blank" href={`https://www.laborstrauss.com${currentLocale === "en" ? `/${currentLocale}` : ``}`}>{t("[REACT_MORE_INFO_LINK]")}</a></p>
        </div>
    );
};
